"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonBlank = void 0;
/*
 * © 2024 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const styled_components_1 = require("../styled-components");
const Button_1 = require("./Button");
/** A div that is styled like a button, but has no interactivity */
exports.ButtonBlank = styled_components_1.styled.div `
  ${({ kind, theme }) => (0, Button_1.getBackground)(kind, theme)};
  box-shadow:
    inset 0 1px 2px #fff3,
    ${({ kind, theme }) => kind === "active" ? "0 0 0 1px " + theme.highlight : "0 1px 2px #0008"};
  border: none;
  color: ${({ kind, theme }) => theme.button.color[kind !== null && kind !== void 0 ? kind : "normal"]};
  padding: 5px 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${({ height }) => typeof height === "string"
    ? height
    : typeof height === "number"
        ? `${height}px`
        : "30px"};
  white-space: nowrap;
  text-overflow: ellipsis;
`;
//# sourceMappingURL=ButtonBlank.js.map